import { IDivisa } from "@/entities";
import { IPaged } from "@/services";
import { IOfertaDemanda } from "@/entities/centros-efectivo-backend/transferencias/ofertaDemanda.types";

export interface ITransferenciasAll {
  tipo: "OFERTA" | "DEMANDA";
  divisa: IDivisa;
  transferencias: IOfertaDemanda[];
  cantidadDisponible: number;
  pagination: IPaged;
  totalElements: number;
}

export enum ETransferenciaType {
  OFERTA = "OFERTA",
  DEMANDA = "DEMANDA",
}
